import CriteriaCondition from '../../spec/criteria-condition';
import ActiveFilter from '../../active-filter';

export default function restoreFiltersFromCriteria({criteria, filterSet}) {
    const criteriaSet = new CriteriaCondition(criteria);
    let activeFilters = [];

    if (criteriaSet.isUnion() && criteriaSet.hasConditions()) {
        activeFilters = criteriaSet.conditions.map((rawCondition) => {
            // TODO consider future case with negative conditions and disjunctions
            const condition = new CriteriaCondition(rawCondition);
            return new ActiveFilter({filter: filterSet[condition.path], condition});
        });
    }
    return activeFilters;
}
